const dateTimeFixtTimeZone = (date: Date) => {
    const dateWithAddedHour = new Date(date);
    dateWithAddedHour.setHours(dateWithAddedHour.getHours() + 1);
    return dateWithAddedHour.toISOString();
}

export default dateTimeFixtTimeZone;
